// src/admin/FormEditor/components/FormHeader/LanguageToggle.jsx
import { Languages } from "lucide-react";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Priority } from "../../../../constants/locale";
import { updateFormMetadata } from "../../store/formEditorSlice";
import { recursiveTranslateChinese } from "../../utils/formTemplates";

const LanguageToggle = () => {
  const dispatch = useDispatch();
  const supportedLanguages = useSelector(
    (state) => state.formEditor.formMetadata.supported_languages
  );
  const formMetadata = useSelector((state) => state.formEditor.formMetadata);

  const handleLanguageToggle = (language) => {
    // First determine the new list of languages
    const newUnsortedLanguages = supportedLanguages.includes(language)
      ? supportedLanguages.filter((l) => l !== language)
      : [...supportedLanguages, language];

    // Sort according to Priority order
    const newSupportedLanguages = Priority.filter((lang) =>
      newUnsortedLanguages.includes(lang)
    );

    dispatch(
      updateFormMetadata({
        updates: { supported_languages: newSupportedLanguages },
      })
    );
  };

  const canTranslateChinese = useCallback(() => {
    return (
      supportedLanguages.includes("tc") && supportedLanguages.includes("sc")
    );
  }, [supportedLanguages]);

  const handleTranslateChinese = (e) => {
    // Create deep copy of original metadata to preserve image data
    const originalMetadata = JSON.parse(JSON.stringify(formMetadata));

    // Translate the form metadata
    const translatedMetadata = recursiveTranslateChinese(formMetadata);

    // Preserve original image data
    const imageFields = [
      "logo_base64",
      "logo_url",
      "banner_base64",
      "banner_url",
    ];

    // Restore original image data
    imageFields.forEach((field) => {
      translatedMetadata[field] = originalMetadata[field];
    });

    const updates = { ...translatedMetadata };
    dispatch(updateFormMetadata({ updates }));
  };

  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center gap-2">
        <label className="block text-sm font-medium text-gray-700">
          Languages
        </label>
        <div className="flex gap-2">
          {Priority.map((language) => (
            <button
              key={language}
              onClick={() => handleLanguageToggle(language)}
              className={`px-3 py-1 rounded text-sm
                ${
                  supportedLanguages.includes(language)
                    ? "bg-blue-600 text-white"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                }`}
            >
              {language.toUpperCase()}
            </button>
          ))}
        </div>
      </div>

      {canTranslateChinese() && (
        <button
          onClick={handleTranslateChinese}
          className="flex items-center gap-1 px-3 py-1 text-blue-600 bg-blue-50
                   rounded hover:bg-blue-100 transition-colors"
          title="Translate TC to SC"
        >
          <Languages size={16} />
          <span className="text-sm">TC → SC</span>
        </button>
      )}
    </div>
  );
};

export default LanguageToggle;
